
import { Product, Table, StockItem, TaxRate, ModifierGroup, Section, PermissionDefinition, Category } from './types';

// Initial Categories for DB seeding
export const INITIAL_CATEGORIES: Category[] = [
  { id: "hot_coffees", name: "Sıcak Kahveler", sortOrder: 1 },
  { id: "cold_coffees", name: "Soğuk Kahveler", sortOrder: 2 },
  { id: "desserts", name: "Tatlılar", sortOrder: 3 },
  { id: "snacks", name: "Atıştırmalıklar", sortOrder: 4 },
  { id: "barista_special", name: "Özel", sortOrder: 5 }
];

// Simple pleasant chime sound (Hosted URL for reliability)
export const NOTIFICATION_SOUND = "/assets/notification.mp3";

export const INITIAL_SECTIONS: Section[] = [
  { id: 1, name: 'Salon' },
  { id: 2, name: 'Bahçe' },
  { id: 3, name: 'Teras' }
];

// Permissions use keys. Display text is handled by translation files.
export const PERMISSIONS: PermissionDefinition[] = [
  { key: 'VIEW_FINANCIALS', label: '', description: '', category: 'Genel' }, // category key: general
  { key: 'VIEW_TABLES', label: '', description: '', category: 'Satış' }, // category key: sales
  { key: 'MANAGE_TABLES', label: 'Masaları Düzenle', description: 'Masa ekleme, silme ve plan düzenleme', category: 'Satış' },
  { key: 'MANAGE_MENU', label: '', description: '', category: 'Yönetim' }, // category key: management
  { key: 'MANAGE_STOCK', label: '', description: '', category: 'Yönetim' },
  { key: 'VIEW_REPORTS', label: '', description: '', category: 'Yönetim' },
  { key: 'MANAGE_STAFF', label: '', description: '', category: 'Yönetim' },
  { key: 'MANAGE_SETTINGS', label: '', description: '', category: 'Yönetim' },
  { key: 'VOID_ITEM', label: '', description: '', category: 'Satış' },
  { key: 'OFFER_COMP', label: '', description: '', category: 'Satış' },
  { key: 'APPLY_DISCOUNT', label: '', description: '', category: 'Satış' },
  { key: 'CLOSE_DAY', label: '', description: '', category: 'Yönetim' },
  { key: 'VIEW_X_REPORT', label: '', description: '', category: 'Yönetim' },
  { key: 'VIEW_Z_REPORT', label: '', description: '', category: 'Yönetim' },
  { key: 'VIEW_DETAILED_REPORT', label: '', description: '', category: 'Yönetim' },
];


export const INITIAL_TAX_RATES: TaxRate[] = [
  { id: 1, name: 'Gıda KDV', rate: 1, description: 'Temel gıda ürünleri için (%1)' },
  { id: 2, name: 'İçecek KDV', rate: 10, description: 'Standart içecekler ve hizmet (%10)' },
  { id: 3, name: 'Alkol KDV', rate: 20, description: 'Alkollü içecekler için yüksek oran (%20)' },
];

export const INITIAL_STOCK: StockItem[] = [
  {
    id: 1,
    name: "Espresso Çekirdek",
    supplier: "Kahve Dünyası",
    stock: 12.5,
    unit: "kg",
    percent: 65,
    cost: 350.00,
    img: "https://ui-avatars.com/api/?name=Espresso+Cekirdek&background=6b7280&color=fff&size=400",
    criticalThreshold: 5,
    warningThreshold: 15
  },
  {
    id: 2,
    name: "Colombia Supremo",
    supplier: "Global Bean",
    stock: 0.8,
    unit: "kg",
    percent: 15,
    cost: 480.00,
    img: "https://ui-avatars.com/api/?name=Colombia+Supremo&background=6b7280&color=fff&size=400",
    critical: true,
    criticalThreshold: 2,
    warningThreshold: 5
  },
  {
    id: 3,
    name: "Tam Yağlı Süt",
    supplier: "Yerel Çiftlik",
    stock: 45,
    unit: "L",
    percent: 80,
    cost: 32.50,
    img: "https://ui-avatars.com/api/?name=Tam+Yagli+Sut&background=f8fafc&color=000&size=400",
    criticalThreshold: 10,
    warningThreshold: 25
  },
  {
    id: 4,
    name: "Vanilya Şurubu",
    supplier: "Monin",
    stock: 5,
    unit: "L",
    percent: 45,
    cost: 350.00,
    img: "https://ui-avatars.com/api/?name=Vanilya+Surubu&background=fef08a&color=000&size=400",
    criticalThreshold: 2,
    warningThreshold: 5
  },
  {
    id: 5,
    name: "Yulaf Sütü",
    supplier: "Alpro",
    stock: 12,
    unit: "L",
    percent: 100,
    cost: 65.00,
    img: "https://ui-avatars.com/api/?name=Yulaf+Sutu&background=fef08a&color=000&size=400",
    criticalThreshold: 5,
    warningThreshold: 10
  },
  {
    id: 6,
    name: "Badem Sütü",
    supplier: "Alpro",
    stock: 8,
    unit: "L",
    percent: 100,
    cost: 75.00,
    img: "https://ui-avatars.com/api/?name=Badem+Sutu&background=fed7aa&color=000&size=400",
    criticalThreshold: 3,
    warningThreshold: 5
  },
  {
    id: 7,
    name: "Laktozsuz Süt",
    supplier: "İçim",
    stock: 15,
    unit: "L",
    percent: 100,
    cost: 38.00,
    img: "https://ui-avatars.com/api/?name=Laktozsuz+Sut&background=f1f5f9&color=000&size=400",
    criticalThreshold: 5,
    warningThreshold: 10
  },
  {
    id: 8,
    name: "Karamel Şurubu",
    supplier: "Monin",
    stock: 3,
    unit: "L",
    percent: 100,
    cost: 350.00,
    img: "https://ui-avatars.com/api/?name=Karamel+Surubu&background=d97706&color=fff&size=400",
    criticalThreshold: 1,
    warningThreshold: 2
  },
  {
    id: 9,
    name: "Fındık Şurubu",
    supplier: "Monin",
    stock: 2,
    unit: "L",
    percent: 100,
    cost: 350.00,
    img: "https://ui-avatars.com/api/?name=Findik+Surubu&background=b45309&color=fff&size=400",
    criticalThreshold: 1,
    warningThreshold: 2
  },
  {
    id: 10,
    name: "Kafeinsiz Çekirdek",
    supplier: "Kahve Dünyası",
    stock: 2,
    unit: "kg",
    percent: 100,
    cost: 400.00,
    img: "https://ui-avatars.com/api/?name=Kafeinsiz+Cekirdek&background=4b5563&color=fff&size=400",
    criticalThreshold: 1,
    warningThreshold: 2
  },
  {
    id: 11,
    name: "Sıvı Krema",
    supplier: "Tikveşli",
    stock: 10,
    unit: "L",
    percent: 100,
    cost: 120.00,
    img: "https://ui-avatars.com/api/?name=Sivi+Krema&background=f8fafc&color=000&size=400",
    criticalThreshold: 2,
    warningThreshold: 5
  }
];

// Renamed to INITIAL_... to indicate it's for DB seeding only now
export const INITIAL_MODIFIER_GROUPS: ModifierGroup[] = [
  {
    id: 1,
    name: 'Sıcaklık',
    allowMultiple: false,
    options: [
      { id: 'temp_hot', name: 'Sıcak', price: 0 },
      { id: 'temp_iced', name: 'Buzlu', price: 5 }
    ]
  },
  {
    id: 2,
    name: 'Süt Seçimi',
    allowMultiple: false,
    options: [
      { id: 'milk_whole', name: 'Tam Yağlı', price: 0, stockId: 3, amount: 0.25 },
      { id: 'milk_oat', name: 'Yulaf Sütü', price: 20, stockId: 5, amount: 0.25 },
      { id: 'milk_almond', name: 'Badem Sütü', price: 25, stockId: 6, amount: 0.25 },
      { id: 'milk_lactose_free', name: 'Laktozsuz', price: 10, stockId: 7, amount: 0.25 },
    ]
  },
  {
    id: 3,
    name: 'Şurup / Aroma',
    allowMultiple: false,
    options: [
      { id: 'syrup_none', name: 'İstemiyorum', price: 0 },
      { id: 'syrup_vanilla', name: 'Vanilya', price: 15, stockId: 4, amount: 0.02 }, // 2cl
      { id: 'syrup_caramel', name: 'Karamel', price: 15, stockId: 8, amount: 0.02 },
      { id: 'syrup_hazelnut', name: 'Fındık', price: 15, stockId: 9, amount: 0.02 },
    ]
  },
  {
    id: 4,
    name: 'Ekstralar',
    allowMultiple: true, // Multiple selection allowed
    options: [
      { id: 'extra_shot', name: 'Extra Shot', price: 30, stockId: 1, amount: 0.018 }, // 18g coffee
      { id: 'extra_decaf', name: 'Kafeinsiz', price: 0, stockId: 10, amount: 0.018 },
      { id: 'extra_cream', name: 'Krema', price: 10, stockId: 11, amount: 0.05 }, // 50ml
    ]
  }
];

export const PRODUCTS: Product[] = [
  {
    id: 1,
    name: "Iced Latte",
    category: "cold_coffees",
    price: 85.00,
    image: "https://ui-avatars.com/api/?name=Iced+Latte&background=d97706&color=fff&size=400",
    stock: 45,
    description: "Espresso, soğuk süt ve buz parçacıkları.",
    customizable: true,
    recipe: [
      { stockId: 1, amount: 0.018 }, // 18g Espresso Beans
      { stockId: 3, amount: 0.25 }   // 250ml Milk
    ]
  },
  {
    id: 2,
    name: "San Sebastian",
    category: "desserts",
    price: 140.00,
    image: "https://ui-avatars.com/api/?name=San+Sebastian&background=f59e0b&color=fff&size=400",
    stock: 12,
    description: "Çikolata soslu, yumuşak dokulu."
  },
  {
    id: 3,
    name: "Caffè Latte",
    category: "hot_coffees",
    price: 75.00,
    image: "https://ui-avatars.com/api/?name=Caffe+Latte&background=b45309&color=fff&size=400",
    stock: 120,
    description: "Zengin espresso ve kadifemsi süt.",
    customizable: true,
    recipe: [
      { stockId: 1, amount: 0.018 },
      { stockId: 3, amount: 0.22 }
    ]
  },
  {
    id: 4,
    name: "Americano",
    category: "hot_coffees",
    price: 65.00,
    image: "https://ui-avatars.com/api/?name=Americano&background=78350f&color=fff&size=400",
    stock: 999,
    description: "Sıcak su ile inceltilmiş espresso.",
    customizable: true,
    recipe: [
      { stockId: 1, amount: 0.018 }
    ]
  },
  {
    id: 5,
    name: "Tiramisu",
    category: "desserts",
    price: 120.00,
    image: "https://ui-avatars.com/api/?name=Tiramisu&background=78350f&color=fff&size=400",
    stock: 8,
    description: "İtalyan klasiği."
  },
  {
    id: 6,
    name: "Kruvasan",
    category: "snacks",
    price: 55.00,
    image: "https://ui-avatars.com/api/?name=Kruvasan&background=fcd34d&color=000&size=400",
    stock: 0,
    description: "Tereyağlı taze kruvasan."
  },
  {
    id: 7,
    name: "Cappuccino",
    category: "hot_coffees",
    price: 95.00,
    image: "https://ui-avatars.com/api/?name=Cappuccino&background=b45309&color=fff&size=400",
    stock: 50,
    description: "Eşit oranlı espresso, süt ve köpük.",
    customizable: true,
    recipe: [
      { stockId: 1, amount: 0.018 },
      { stockId: 3, amount: 0.18 }
    ]
  },
  {
    id: 8,
    name: "Cold Brew",
    category: "cold_coffees",
    price: 95.00,
    image: "https://ui-avatars.com/api/?name=Cold+Brew&background=451a03&color=fff&size=400",
    stock: 20,
    description: "12 saat demlenmiş soğuk kahve.",
    customizable: true,
    recipe: [
      { stockId: 2, amount: 0.045 } // 45g special beans
    ]
  }
];

export const TABLES: Table[] = [
  { id: 1, name: "Masa 1", section: "Salon", status: "empty", capacity: 4 },
  { id: 2, name: "Masa 2", section: "Salon", status: "empty", capacity: 2 },
  { id: 3, name: "Masa 3", section: "Salon", status: "empty", capacity: 6 },
  { id: 4, name: "Masa 4", section: "Salon", status: "empty", capacity: 4 },
  { id: 5, name: "Masa 5", section: "Bahçe", status: "empty", capacity: 8 },
  { id: 6, name: "Masa 6", section: "Bahçe", status: "empty", capacity: 4 },
  { id: 7, name: "Masa 7", section: "Bahçe", status: "empty", capacity: 2 },
  { id: 8, name: "Masa 8", section: "Bahçe", status: "empty", capacity: 4 },
  { id: 9, name: "Masa 9", section: "Teras", status: "empty", capacity: 4 },
  { id: 10, name: "Masa 10", section: "Teras", status: "empty", capacity: 2 },
  { id: 11, name: "Masa 11", section: "Teras", status: "empty", capacity: 6 },
  { id: 12, name: "Masa 12", section: "Teras", status: "empty", capacity: 4 },
];
